import { makeStyles } from "@material-ui/core/styles";

export const useTipStyles = makeStyles((theme) => ({
  section: {
    padding: "16px",
    paddingTop: "8px",
    paddingLeft: "0",
    paddingRight: "16px",
    maxHeight: "calc(100vh - 140px)",
    overflowY: "auto",
    maxWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: "15px",
      backgroundColor: "#1a1a1a",
      paddingBottom: "86px",
      height: "calc(100vh - 80px)",
      paddingRight: "15px",
    },
  },
  sectionTitle: {
    color: "#f06ec4",
    fontWeight: 600,
    fontSize: "24.5px",
    marginBottom: "3px",
  },
  infoText: {
    color: "white",
    fontSize: "11px",
    marginBottom: "30px",
  },
  settingsCard: {
    backgroundColor: "#1E1E1E",
    borderRadius: "8px",
    marginBottom: "16px",
    border: "1px solid #363636",
  },
  cardContent: {
    padding: "20px !important",
  },
  formRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    gap: "16px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "12px",
      width: "100%",
    },
  },
  label: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 500,
    minWidth: "150px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
      fontSize: "16px",
      marginBottom: "4px",
    },
  },
  inputField: {
    flex: 1,
    maxWidth: "200px",
    "& .MuiInputBase-root": {
      color: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EDECED",
      },
      "&:hover fieldset": {
        borderColor: "#f06ec4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f06ec4",
      },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
        "&::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
      },
    },
  },
  suggestedAmountsContainer: {
    marginTop: "20px",
  },
  suggestedAmountsTitle: {
    color: "#f06ec4",
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "16px",
  },
  amountsGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "16px",
  },
  amountChip: {
    backgroundColor: "#333",
    color: "white",
    fontSize: "14px",
    padding: "8px 12px",
    "&:hover": {
      backgroundColor: "#444",
    },
  },
  addAmountContainer: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    marginTop: "16px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "12px",
    },
  },
  addAmountInput: {
    width: "120px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiInputBase-root": {
      color: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EDECED",
      },
      "&:hover fieldset": {
        borderColor: "#f06ec4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f06ec4",
      },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
        "&::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
      },
    },
  },
  addButton: {
    backgroundColor: "#f06ec4",
    color: "white",
    minWidth: "60px",
    "&:hover": {
      backgroundColor: "#d45ca5",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minWidth: "auto",
    },
  },
  saveButton: {
    backgroundColor: "#f06ec4",
    color: "white",
    float: "right",
    marginTop: "20px",
    "&:hover": {
      backgroundColor: "#d45ca5",
    },
    [theme.breakpoints.down("sm")]: {
      float: "none",
      width: "100%",
      marginTop: "16px",
    },
  },
  customTipSection: {
    marginTop: "20px",
    padding: "16px",
    backgroundColor: "#2a2a2a",
    borderRadius: "8px",
  },
  customTipTitle: {
    color: "#f06ec4",
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "12px",
  },
  customTipDescription: {
    color: "#ccc",
    fontSize: "12px",
    marginBottom: "16px",
  },
}));
